import { useMemo } from 'react';

import { useGameStateSlice } from '@pp/core';

import { Bets, BetMapping } from '../../../config/bets';
import { useMWStateSlice } from '../../../store/slices/mwState/selectors';

export const useMegaWheelValueSpotConnected = (betSpot: Bets, options?: { raw?: boolean }) => {
  const megaWinValue = useMWStateSlice.megaWinValue();
  const winResult = useGameStateSlice.winResult();
  const gameResult = useMWStateSlice.getGameResult();
  return useMemo(() => {
    if (megaWinValue && megaWinValue.number)
      return betSpot == BetMapping[megaWinValue.number] ? megaWinValue?.multiplier : 0;
  }, [megaWinValue, winResult, gameResult, betSpot, options]);
};
